export default __webpack_public_path__ + "static/charmander-7f7b6865a2664500802d406e2e337799.png";